// src/stores/StoreContext.tsx
import React from 'react';
import NetworkOptimizationStore from './store';

const NetworkContext = React.createContext(NetworkOptimizationStore.empty());
export {NetworkContext};